export default __webpack_public_path__ + "static/media/include_13_female@2x.1fbc4230.jpg";